if (!window.Eurus?.loadedScript?.has('animated-text.js')) {
  window.Eurus.loadedScript.add('animated-text.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xAnimatedText', (texts, options = {}) => ({
        texts: Array.isArray(texts) ? texts.filter((t) => typeof t === 'string' && t.trim() !== '') : [],
        index: 0,
        charIndex: 0,
        direction: 'forward', // forward | back
        current: '',
        timer: null,

        typeSpeed: Number(options.typeSpeed ?? 85),
        deleteSpeed: Number(options.deleteSpeed ?? 55),
        holdDelay: Number(options.holdDelay ?? 1200),
        loopDelay: Number(options.loopDelay ?? 300),

        tick() {
          if (!this.texts.length) return;

          const full = this.texts[this.index] ?? '';

          if (this.direction === 'forward') {
            this.charIndex = Math.min(full.length, this.charIndex + 1);
            this.current = full.slice(0, this.charIndex);

            if (this.charIndex >= full.length) {
              this.direction = 'back';
              this.timer = setTimeout(() => this.tick(), this.holdDelay);
              return;
            }

            this.timer = setTimeout(() => this.tick(), this.typeSpeed);
            return;
          }

          // back
          this.charIndex = Math.max(0, this.charIndex - 1);
          this.current = full.slice(0, this.charIndex);

          if (this.charIndex <= 0) {
            this.direction = 'forward';
            this.index = (this.index + 1) % this.texts.length;
            this.timer = setTimeout(() => this.tick(), this.loopDelay);
            return;
          }

          this.timer = setTimeout(() => this.tick(), this.deleteSpeed);
        },

        init() {
          if (!this.texts.length) return;
          this.index = 0;
          this.charIndex = 0;
          this.direction = 'forward';
          this.current = '';
          this.tick();
        },

        destroy() {
          if (this.timer) clearTimeout(this.timer);
          this.timer = null;
        },
      }));
    });
  });
}

